import { useMemo } from 'react';
import { useWebSocket } from '../../../contexts/SocketContext';
import useNodesProjectStore from '../stores/useNodesProjectStore';
import { getLockedDesignIds, getLockedMappingIds } from '../utils/ruleGenerationLock';


export function useRuleGenerationLock(projectId) {
  const { data: socketData } = useWebSocket();
  const elements = useNodesProjectStore((s) => s.elements);
  const project = useNodesProjectStore((s) => s.project);

  const socketProject =
    projectId != null
      ? socketData?.[projectId] ?? socketData?.[String(projectId)] ?? null
      : undefined;

  return useMemo(() => {
    if (projectId == null || String(projectId) === '') {
      return {
        lockedDesignIds: new Set(),
        lockedMappingIds: new Set(),
      };
    }
    const params = { elements, project, socketProject };
    return {
      lockedDesignIds: getLockedDesignIds(params),
      lockedMappingIds: getLockedMappingIds(params),
    };
  }, [projectId, elements, project, socketData]);
}
